/**
 * close button class
 */


export default class CloseButton {

	constructor(options) {
		this.id = options.id;
		this.events = options.events;
		this.init.call(this);
		return this;
	}

    /**
     *
     */
	init() {
		this.button = document.getElementById(this.id);
		this.listener = this.registerListener();
	}

	/**
	 * handle the buttons click event and return the event listener
	 * @return
	 */
	registerListener() {
		return this.button.addEventListener('click', this.onClick.bind(this));
	}

	/**
	 *
	 * @param   Object
	 * @chainable
	 */
	onClick(event) {
		this.events.emit('menu--close', {}, event);
		return this;
	}

}